import { useState } from "react";
import { MdClose, MdSend } from "react-icons/md";
import { createNotification, updateNotification } from "api/pushNotification.api";

export default function BulkNotificationForm({ initialData, onSubmit, onClose }) {
  const [form, setForm] = useState({
    title: initialData?.title || "",
    message: initialData?.message || "",
    send_type: initialData?.send_type || "all",
    fcm_token: initialData?.fcm_token || "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    setError("");
    if (!form.title.trim()) return setError("Title is required");
    if (!form.message.trim()) return setError("Message is required");
    if (form.send_type === "token" && !form.fcm_token.trim())
      return setError("FCM Token is required for single device");

    setLoading(true);
    try {
      if (initialData?._id) {
        await updateNotification(initialData._id, form);
      } else {
        await createNotification(form);
      }
      await onSubmit();
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-navy-700">
          {initialData?._id ? "Edit Notification" : "Push Notification"}
        </h2>
        {/* <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <MdClose size={22} />
        </button> */}
      </div>

      <div className="space-y-4 max-w-lg">
        {/* <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Send To
          </label>
          <select
            name="send_type"
            value={form.send_type}
            onChange={handleChange}
            className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
          >
            <option value="all">All Users</option>
            <option value="token">Single Device (FCM Token)</option>
          </select>
        </div>

        {form.send_type === "token" && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              FCM Token
            </label>
            <input
              type="text"
              name="fcm_token"
              value={form.fcm_token}
              onChange={handleChange}
              placeholder="Enter device FCM token"
              className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
            />
          </div>
        )} */}

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notification Title <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="title"
            className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notification Message <span className="text-red-500">*</span>
          </label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="message"
            rows={4}
            className="w-full border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand-500 resize-none"
          />
        </div>

        {error && (
          <p className="text-red-500 text-sm">{error}</p>
        )}

        <div className="flex gap-3 pt-2">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="flex items-center gap-2 px-5 py-2 bg-brand-500 hover:bg-brand-600 text-white rounded-lg text-sm font-medium disabled:opacity-60"
          >
            <MdSend size={16} />
            {loading ? "Sending..." : initialData?._id ? "Update" : "Create"}
          </button>
          {/* <button
            onClick={onClose}
            className="px-5 py-2 border rounded-lg text-sm text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </button> */}
        </div>
      </div>
    </div>
  );
}